import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const featuredMovies = movies.filter((m) => m.featured).slice(0, 3);

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-3">
        {featuredMovies.map((movie, idx) => (
          <div key={movie.id} className="relative overflow-hidden">
            <img
              src={movie.landscapeUrl}
              alt={movie.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-foreground-900/50"></div>
          </div>
        ))}
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/20 via-foreground-900/10 to-foreground-900/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          西瓜影视
        </h1>
        <p className="text-background-50/80 text-sm md:text-lg max-w-2xl mb-8 leading-relaxed">
          海量高清影视，蓝光超清画质，流畅不缓冲<br className="hidden md:block" />
          随时随地畅享极致观影体验
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/dianying"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-play-circle-line"></i>
            </div>
            开始观影
          </Link>
          <Link
            to="/category/dianshiju"
            className="bg-background-50/20 backdrop-blur-sm hover:bg-background-50/30 text-background-50 border border-background-50/30 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-tv-2-line"></i>
            </div>
            热播剧集
          </Link>
        </div>

        <div className="flex items-center gap-2 mt-8">
          {featuredMovies.map((movie, idx) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                idx === 0
                  ? 'w-6 bg-primary-500'
                  : 'bg-background-50/40 hover:bg-background-50/70'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}